import type { ComponentType } from 'react';

import { lazyWithRetry } from 'utils/lazy.utils';

export type AppThemeMode = 'light' | 'dark';

export const getReactJsonTheme = (themeMode: AppThemeMode): string =>
  themeMode === 'dark' ? 'monokai' : 'rjv-default';

/**
 * Vite dynamic-imports CJS `react-json-view` as a module namespace whose
 * `default` is often still a Module (not a component). Unwrap until we get a
 * function so React.lazy can mount it.
 */
const resolveReactJsonComponent = (mod: unknown): ComponentType<any> => {
  let current: any = mod;
  // Walk nested `.default` from CJS interop (rarely more than 2 levels).
  for (let i = 0; i < 3 && current && typeof current !== 'function'; i += 1) {
    current = current.default ?? current;
  }
  if (typeof current !== 'function') {
    throw new Error('react-json-view did not resolve to a React component');
  }
  return current;
};

export const LazyReactJson = lazyWithRetry(() =>
  import('react-json-view').then(mod => ({
    default: resolveReactJsonComponent(mod),
  })),
);
